import { auth } from "../../../firebase";

export const checkAuthState = (callback) => {
    auth.onAuthStateChanged((user) => {
      // If user is logged in, user will be truthy
      const isLoggedIn = !!user;
      callback(isLoggedIn);
    });
  };
  